import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDesktop,
  faPeopleArrows,
  faProjectDiagram,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import "./index.css";

const Stat = () => {
  return (
    <section id="stat">
      <div className="Stat" style={{ backgroundColor: "#00629B" }}>
        <div class="section-header">
          <h3 style={{ color: "white", fontSize: "45px", fontWeight: "800" }}>
            WHAT WE DO
          </h3>
        </div>
        <div className="container container-y">
          <div className="row rows-cols-5 mt-5 justify-content-center">
            <div className="cards cards-y">
              <div className="card-item card-item-y">
                <div className="card-info card-info-y">
                  <h2 className="card-title card-title-y">
                    <FontAwesomeIcon icon={faDesktop} /> Workshops
                  </h2>
                  <p className="card-intro card-intro-y">
                    Comprehensive knowledge plays a major role on setting sights
                    to the advancing technological world. Workshops help in
                    boosting up the students to investigate and expand their
                    scope.
                  </p>
                </div>
              </div>
            </div>
            <div className="cards cards-y">
              <div className="card-item card-item-y">
                <div className="card-info card-info-y">
                  <h2 className="card-title card-title-y">
                    <FontAwesomeIcon icon={faUsers} /> Competitions
                  </h2>
                  <p className="card-intro card-intro-y">
                    In motivating students to develop skills and clinch to
                    greater heights and excel in the IT field. This gives them
                    the opportunity to uncover and showcase their talents.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row rows-cols-5 justify-content-center">
            <div className="cards cards-y">
              <div className="card-item card-item-y">
                <div className="card-info card-info-y">
                  <h2 className="card-title card-title-y">
                    <FontAwesomeIcon icon={faProjectDiagram} /> Events and
                    Activities
                  </h2>
                  <p className="card-intro card-intro-y">
                    Engaging in meaningful and interesting volunteering
                    experiences bring fun and fulfillment to life while paving a
                    way for our members to explore their interests and passions.
                  </p>
                </div>
              </div>
            </div>
            <div className="cards cards-y">
              <div className="card-item card-item-y">
                <div className="card-info card-info-y">
                  <h2 className="card-title card-title-y">
                    <FontAwesomeIcon icon={faPeopleArrows} /> Member Development
                  </h2>
                  <p className="card-intro card-intro-y">
                    The perfect platform for colleagues to engage in dynamic
                    environments which emphasize co-creation and collaboration
                    to develop their distinct and unique personalities and
                    professionalism.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="hidden">
          <svg
            xmlns={"http://www.w3.org/2000/svg"}
            id={"view"}
            viewBox={"0 0 933.44272 783.89357"}
          >
            <title>lists</title>
            <path
              d="M627.33188,841.14167c0,15.28692-94.57823,27.67192-211.44706,27.7519h-1.06254c-57.04625,0-108.84836-2.93629-147.02008-7.7006-1.6338-.21709-3.2448-.42273-4.82149-.63981-6.48953-.8569-12.55633-1.78234-18.1433-2.74209-26.70079-4.65009-42.52473-10.41982-42.52473-16.6694,0-5.06144,10.35127-9.79144,28.43745-13.8817,9.55149-2.15939,21.25094-4.1245,34.73271-5.86116q3.719-.497,7.63206-.93688c37.60053-4.39869,87.26605-7.07223,141.70738-7.07223,10.57979,0,20.98817.10286,31.15667.29707C548.56622,815.65188,627.33188,827.19142,627.33188,841.14167Z"
              transform="translate(-73.77864 -85)"
              fill="#3f3d56"
            />
            <rect
              x="617.70498"
              y="416.06562"
              width="314.75413"
              height="161.31149"
              fill="#f2f2f2"
            />
            <rect
              x="226.22953"
              y="0.98361"
              width="314.75413"
              height="161.31149"
              fill="#f2f2f2"
            />
            <path
              d="M615.74591,248.27871H299.02457V85H615.74591Zm-314.75413-1.96722H613.7787V86.96721H300.99178Z"
              transform="translate(-73.77864 -85)"
              className=" fill-primary"
            />
            <rect
              x="617.70498"
              y="0.98361"
              width="314.75413"
              height="161.31149"
              fill="#f2f2f2"
            />
            <rect
              x="226.22953"
              y="208.52461"
              width="314.75413"
              height="161.31149"
              fill="#f2f2f2"
            />
            <rect
              x="617.70498"
              y="208.52461"
              width="314.75413"
              height="161.31149"
              fill="#f2f2f2"
            />
            <rect
              x="226.22953"
              y="416.06562"
              width="314.75413"
              height="161.31149"
              fill="#f2f2f2"
            />
            <path
              d="M580.49352,662.04422q-19.18523-3.25031-36.90106-5.58273l4.669-9.05252c-1.57439-.54682-8.49144,4.63729-8.49144,4.63729l6.1273-26.27728c-7.9182.9549-11.9441,27.78561-11.9441,27.78561l-8.84669-9.07128,4.283,10.1985a816.82143,816.82143,0,0,0-93.62328-5.89217l3.99619-7.748c-1.57439-.54682-8.49144,4.63729-8.49144,4.63729l6.12729-26.27729c-7.91819.95491-11.9441,27.78562-11.9441,27.78562l-8.84668-9.07129,4.53634,10.80189a525.9061,525.9061,0,0,0-53.82008,3.65579c4.042-12.07,17.7728-23.54953,17.7728-23.54953-10.48615,3.11875-15.98671,8.34487-18.86091,13.21713a211.63887,211.63887,0,0,1,12.23271-73.124s-21.67451,47.16568-18.90888,78.82526l.33079,5.62183c-18.3751,2.63107-25.60407,8.81279-25.60407,8.81279Z"
              transform="translate(-73.77864 -85)"
              fill="#3f3d56"
            />
            <circle cx="355.70497" cy="255.58758" r="34.78687" fill="#ff6584" />
            <polygon
              points="728.996 475.767 724.918 472.504 747.757 452.112 805.67 452.112 805.67 470.057 768.149 495.343 728.996 475.767"
              fill="#3f3d56"
            />
            <polygon
              points="816.229 463.551 816.229 452.52 808.54 452.52 808.54 455.221 805.67 452.112 786.909 472.504 779.568 477.398 768.186 560.56 785.352 577.726 825.246 577.726 825.246 473.32 816.229 463.551"
              fill="#ccc"
            />
            <rect
              x="724.91811"
              y="472.50395"
              width="61.99121"
              height="105.22193"
              fill="#f2f2f2"
            />
            <rect
              x="748.98049"
              y="552.03216"
              width="11.41943"
              height="25.69373"
              fill="#ccc"
            />
            <polygon
              points="736.745 559.373 736.745 555.295 731.851 555.295 731.851 559.373 736.338 559.373 736.745 559.373"
              fill="#3f3d56"
            />
            <polygon
              points="736.338 562.636 731.851 562.636 731.851 566.714 736.745 566.714 736.745 562.636 736.338 562.636"
              fill="#3f3d56"
            />
            <rect
              x="740.00807"
              y="555.29485"
              width="4.89404"
              height="4.07837"
              fill="#3f3d56"
            />
            <rect
              x="740.00807"
              y="562.63592"
              width="4.89404"
              height="4.07837"
              fill="#3f3d56"
            />
            <polygon
              points="770.188 559.373 770.188 555.295 765.294 555.295 765.294 559.373 769.78 559.373 770.188 559.373"
              fill="#3f3d56"
            />
            <polygon
              points="769.78 562.636 765.294 562.636 765.294 566.714 770.188 566.714 770.188 562.636 769.78 562.636"
              fill="#3f3d56"
            />
            <rect
              x="773.4507"
              y="555.29485"
              width="4.89404"
              height="4.07837"
              fill="#3f3d56"
            />
            <rect
              x="773.4507"
              y="562.63592"
              width="4.89404"
              height="4.07837"
              fill="#3f3d56"
            />
            <polygon
              points="804.446 477.806 804.446 473.727 799.552 473.727 799.552 477.806 804.038 477.806 804.446 477.806"
              fill="#3f3d56"
            />
            <polygon
              points="804.038 481.069 799.552 481.069 799.552 485.147 804.446 485.147 804.446 481.069 804.038 481.069"
              fill="#3f3d56"
            />
            <rect
              x="807.709"
              y="473.72747"
              width="4.89404"
              height="4.07837"
              fill="#3f3d56"
            />
            <rect
              x="807.709"
              y="481.06853"
              width="4.89404"
              height="4.07837"
              fill="#3f3d56"
            />
            <polygon
              points="804.446 500.645 804.446 496.566 799.552 496.566 799.552 500.645 804.038 500.645 804.446 500.645"
              fill="#3f3d56"
            />
            <polygon
              points="804.038 503.907 799.552 503.907 799.552 507.986 804.446 507.986 804.446 503.907 804.038 503.907"
              fill="#3f3d56"
            />
            <rect
              x="807.709"
              y="496.56633"
              width="4.89404"
              height="4.07837"
              fill="#3f3d56"
            />
            <rect
              x="807.709"
              y="503.9074"
              width="4.89404"
              height="4.07837"
              fill="#3f3d56"
            />
            <polygon
              points="804.446 523.484 804.446 519.405 799.552 519.405 799.552 523.484 804.038 523.484 804.446 523.484"
              fill="#3f3d56"
            />
            <polygon
              points="804.038 526.746 799.552 526.746 799.552 530.825 804.446 530.825 804.446 526.746 804.038 526.746"
              fill="#3f3d56"
            />
            <rect
              x="807.709"
              y="519.4052"
              width="4.89404"
              height="4.07837"
              fill="#3f3d56"
            />
            <rect
              x="807.709"
              y="526.74627"
              width="4.89404"
              height="4.07837"
              fill="#3f3d56"
            />
            <polygon
              points="804.446 546.322 804.446 542.244 799.552 542.244 799.552 546.322 804.038 546.322 804.446 546.322"
              fill="#3f3d56"
            />
            <polygon
              points="804.038 549.585 799.552 549.585 799.552 553.664 804.446 553.664 804.446 549.585 804.038 549.585"
              fill="#3f3d56"
            />
            <rect
              x="807.709"
              y="542.24407"
              width="4.89404"
              height="4.07837"
              fill="#3f3d56"
            />
            <rect
              x="807.709"
              y="549.58514"
              width="4.89404"
              height="4.07837"
              fill="#3f3d56"
            />
            <rect
              x="731.85133"
              y="477.80583"
              width="47.30908"
              height="9.78809"
              fill="#3f3d56"
            />
            <rect
              x="731.85133"
              y="497.38201"
              width="47.30908"
              height="9.78809"
              fill="#3f3d56"
            />
            <rect
              x="731.85133"
              y="516.95818"
              width="47.30908"
              height="9.78809"
              fill="#3f3d56"
            />
            <rect
              x="731.85133"
              y="536.53435"
              width="47.30908"
              height="9.78809"
              fill="#3f3d56"
            />
            <polygon
              points="355.902 469.793 397.421 469.793 397.421 459.771 420.328 459.771 420.328 469.793 463.279 469.793 463.279 514.176 420.328 514.176 420.328 570.012 397.421 570.012 397.421 514.176 355.902 514.176 334.426 489.837 355.902 469.793"
              fill="#3f3d56"
            />
            <path
              d="M551.81148,454.8361h-1.96722a96.39345,96.39345,0,1,0-192.7869,0h-1.96721a98.36067,98.36067,0,0,1,196.72133,0Z"
              transform="translate(-73.77864 -85)"
              fill="#3f3d56"
            />
            <rect
              x="404.17666"
              y="355.98722"
              width="2.51384"
              height="99.29687"
              transform="matrix(1, -0.00188, 0.00188, 1, -74.53899, -84.23861)"
              fill="#3f3d56"
            />
            <path
              d="M429.821,368.59564c.22517,34.72128-24.15028,63.0277-24.15028,63.0277s-24.74052-27.98789-24.96569-62.70917,24.15027-63.0277,24.15027-63.0277S429.59582,333.87436,429.821,368.59564Z"
              transform="translate(-73.77864 -85)"
              className="fill-primary"
            />
            <path
              d="M429.821,368.59564c.22517,34.72128-24.15028,63.0277-24.15028,63.0277s-24.74052-27.98789-24.96569-62.70917,24.15027-63.0277,24.15027-63.0277S429.59582,333.87436,429.821,368.59564Z"
              transform="translate(-73.77864 -85)"
              opacity="0.1"
            />
            <rect
              x="371.49674"
              y="356.04854"
              width="2.51384"
              height="99.29687"
              transform="matrix(1, -0.00188, 0.00188, 1, -74.53916, -84.29992)"
              fill="#3f3d56"
            />
            <path
              d="M397.14106,368.657c.22518,34.72128-24.15027,63.0277-24.15027,63.0277s-24.74052-27.9879-24.96569-62.70918,24.15027-63.0277,24.15027-63.0277S396.91589,333.93568,397.14106,368.657Z"
              transform="translate(-73.77864 -85)"
              className="fill-primary"
            />
            <rect
              x="465.54425"
              y="291.88024"
              width="1.99013"
              height="78.61032"
              fill="#3f3d56"
            />
            <path
              d="M559.67971,386.89823c.12669,27.48807-19.21262,49.86116-19.21262,49.86116s-19.54472-22.19388-19.67141-49.68195,19.21263-49.86116,19.21263-49.86116S559.553,359.41015,559.67971,386.89823Z"
              transform="translate(-73.77864 -85)"
              className="fill-primary"
            />
            <circle cx="770.60875" cy="291.63937" r="68.40773" fill="#3f3d56" />
            <polygon
              points="777.45 266.171 777.45 294.807 735.823 294.807 728.132 304.034 729.01 294.807 725.269 294.807 725.269 266.171 777.45 266.171"
              className="fill-primary blink"
            />
            <rect
              x="758.67717"
              y="276.03476"
              width="18.77235"
              height="18.77235"
              opacity="0.1"
            />
            <polygon
              points="762.813 280.171 814.994 280.171 814.994 308.807 811.252 308.807 812.131 318.034 804.441 308.807 762.813 308.807 762.813 280.171"
              className="fill-primary"
            />
            <ellipse
              cx="728.4505"
              cy="307.53414"
              rx="11.45432"
              ry="1.11749"
              opacity="0.1"
            />
            <ellipse
              cx="812.13065"
              cy="322.48838"
              rx="13.04519"
              ry="1.2727"
              opacity="0.1"
            />
            <path
              d="M883.2215,106.0316H838.018a9.60936,9.60936,0,0,0-9.37409,7.496L805.80347,214.83763a7.76645,7.76645,0,0,0,7.1941,9.46513l46.46951,2.28955a10.2603,10.2603,0,0,0,10.60137-8.42156l12.95649-71.62734.9639.2754,2.47911-13.57606-.99221-.24805,3.61661-19.99376A5.91643,5.91643,0,0,0,883.2215,106.0316Z"
              transform="translate(-73.77864 -85)"
              fill="#3f3d56"
            />
            <path
              d="M843.969,108.21557h-5.27661a6.64081,6.64081,0,0,0-6.48818,5.22521l-21.92367,100.4835a4.11488,4.11488,0,0,0,3.75119,4.98323l46.31918,3.03571a5.32916,5.32916,0,0,0,5.59329-4.37305l18.70761-103.85948a4.66768,4.66768,0,0,0-4.59375-5.49512h-5.00569a2.20288,2.20288,0,0,0-2.12714,1.6302h0a1.94476,1.94476,0,0,1-1.87789,1.43917h-23.7638a3.32434,3.32434,0,0,1-3.31454-3.06937Z"
              transform="translate(-73.77864 -85)"
              className="fill-primary"
            />
            <circle
              cx="389.94677"
              cy="81.78849"
              r="65.46092"
              className="fill-primary blink"
            />
            <path
              d="M520.72517,207.888c-12.56848.00078-40.32306-12.90833-65.00687-28.02709-30.63032-18.761-60.3785-43.28289-55.17787-51.77425,1.47-2.39963,5.11342-3.02717,11.14053-1.92079l-.43212,2.35291c-4.66729-.85879-7.82566-.559-8.66849.81675-1.2294,2.00722,1.48128,7.83423,12.77519,18.16852,10.29225,9.41867,25.07038,20.18508,41.61241,30.31694,16.54164,10.13186,32.84776,18.40443,45.91376,23.294,14.33783,5.36608,20.76007,5.13172,21.9887,3.12606.844-1.37811-.32857-4.33132-3.21755-8.10362l1.899-1.45441c3.73063,4.87167,4.82923,8.40649,3.35847,10.8069C525.90049,207.139,523.75351,207.888,520.72517,207.888Z"
              transform="translate(-73.77864 -85)"
              fill="#3f3d56"
            />
            <circle cx="381.86671" cy="48.14092" r="13.38973" fill="#fff" />
            <circle cx="385.74494" cy="121.54293" r="8.92649" fill="#fff" />
            <circle cx="416.48373" cy="90.94044" r="8.92649" fill="#fff" />
            <path
              d="M1007.22136,663.36071H690.5V500.082h316.72134ZM692.46723,661.3935h312.78692V502.04922H692.46723Z"
              transform="translate(-73.77864 -85)"
              className="fill-primary"
            />
            <path
              d="M1005.25415,456.80332H688.5328V293.52461h316.72135ZM690.5,454.8361h312.78691V295.49182H690.5Z"
              transform="translate(-73.77864 -85)"
              className="fill-primary"
            />
            <path
              d="M298.18879,805.30317c5.36982,19.85008,23.76267,32.14374,23.76267,32.14374s9.68665-19.88969,4.31683-39.73977-23.76267-32.14374-23.76267-32.14374S292.819,785.45308,298.18879,805.30317Z"
              transform="translate(-73.77864 -85)"
              fill="#3f3d56"
            />
            <path
              d="M306.07936,801.03717c14.73487,14.3438,16.53462,36.39356,16.53462,36.39356s-22.09018-1.20614-36.825-15.54994-16.53463-36.39355-16.53463-36.39355S291.34449,786.69337,306.07936,801.03717Z"
              transform="translate(-73.77864 -85)"
              className="fill-primary"
            />
            <path
              d="M357.556,528.63387l-15.70335,1.74482s-6.97927,31.4067,0,73.28231S357.556,687.41221,357.556,687.41221s6.97927,136.09571,10.4689,137.84053,34.89634,12.21372,36.64115,1.74482,1.74482-249.50882,1.74482-249.50882l24.42744,115.15792s3.48963,144.8198,10.4689,144.8198,29.66188-1.74482,29.66188-13.95854S476.20354,650.771,476.20354,650.771s-1.74481-118.64754-8.72408-122.13718S357.556,528.63387,357.556,528.63387Z"
              transform="translate(-73.77864 -85)"
              fill="#2f2e41"
            />
            <path
              d="M371.51453,820.01829s-15.70335-1.74482-19.193,0-8.72409,13.95853,0,20.9378,31.4067,17.44817,38.386,17.44817,13.95853-3.48963,13.95853-3.48963l-3.48963-29.66189Z"
              transform="translate(-73.77864 -85)"
              fill="#2f2e41"
            />
            <path
              d="M441.30721,828.74237l1.74481,24.42744s22.68262,3.48963,24.42744,0,19.193-12.21372,20.9378-13.95854,3.48964-20.9378-6.97926-22.68262-13.95854,3.48964-13.95854,3.48964Z"
              transform="translate(-73.77864 -85)"
              fill="#2f2e41"
            />
            <path
              d="M481.85415,321.01532s38.147-24.53087,37.26414-41.38406-23.87951-69.9918-23.87951-69.9918-17.99016-37.4032-25.14209-22.11729,9.39989,31.55733,9.39989,31.55733l10.6833,52.12683-29.03429,27.69849Z"
              transform="translate(-73.77864 -85)"
              fill="#a0616a"
            />
            <circle cx="313.43924" cy="169.69762" r="31.4067" fill="#a0616a" />
            <path
              d="M371.51453,273.89061l5.23445,33.15152,38.386-6.97927s-1.74481-33.15152-1.74481-36.64115S371.51453,273.89061,371.51453,273.89061Z"
              transform="translate(-73.77864 -85)"
              fill="#a0616a"
            />
            <path
              d="M369.76972,307.04213s43.62042-10.4689,48.85487-6.97927,31.4067,6.97927,31.4067,6.97927l29.66189,45.36524-8.72409,57.57895s-1.74481,92.4753,1.74482,108.17865,22.68262,17.44817-17.44817,20.9378-47.11-1.74481-75.02712,5.23445-50.59969-3.48963-43.62042-10.4689,19.193-118.64754,5.23445-129.11645-19.193-64.55822-19.193-64.55822S369.76972,315.76621,369.76972,307.04213Z"
              transform="translate(-73.77864 -85)"
              fill="#3f3d56"
            />
            <path
              d="M444.79684,312.27658l5.23445-5.23445,10.4689-10.4689s34.02393,14.83094,32.27912,20.06539-13.08613,35.76875-13.08613,35.76875l-15.70335,5.23445Z"
              transform="translate(-73.77864 -85)"
              fill="#3f3d56"
            />
            <path
              d="M398.17835,216.64808l-.32186-2.51594a19.77829,19.77829,0,0,0-6.2856.9877,10.32665,10.32665,0,0,1,.388-4.52107,20.103,20.103,0,0,0-5.81783,2.52934l-1.26884-4.59162-17.4426,8.59632c-6.26123,3.08575-12.86249,6.47669-16.44172,12.46952-3.99031,6.68112-3.29591,15.26752-.56816,22.55582s7.26036,13.73814,10.89358,20.62a51.51652,51.51652,0,0,0,4.95064,8.426c6.58389,8.20751,19.3997,9.86569,28.68263,4.91211,3.42591-1.82815,6.53859-4.56058,7.948-8.17894.84275-2.16359,1.03547-4.51792,1.58763-6.77324,1.14826-4.69012,2.48122-14.37168,6.29067-17.3388,1.67631-1.30565,4.99988,3.02263,6.389,1.41483,3.5699-4.13179,2.82068-10.5038.60359-15.494a113.05265,113.05265,0,0,0-7.4426-14.51667C409.125,223.35867,398.13974,216.3463,398.17835,216.64808Z"
              transform="translate(-73.77864 -85)"
              fill="#2f2e41"
            />
            <path
              d="M294.74259,382.06926S252.867,422.2,258.10144,443.13785s47.11005,82.00639,47.11005,82.00639,40.13079,20.9378,45.36524,0-27.91707-15.70335-27.91707-15.70335l-26.17225-62.81341,29.66188-41.87561Z"
              transform="translate(-73.77864 -85)"
              fill="#a0616a"
            />
            <path
              d="M343.59746,343.68328l-20.9378-3.48963s-15.70335,17.44817-20.9378,24.42744-15.70335,24.42743-15.70335,24.42743l36.64115,26.17226,27.91707-29.66189Z"
              transform="translate(-73.77864 -85)"
              fill="#3f3d56"
            />
          </svg>

          <svg
            xmlns={"http://www.w3.org/2000/svg"}
            id={"like"}
            viewBox={"0 0 943.07028 710"}
          >
            <title>like</title>
            <path
              d="M933.25616,166.39389c-7.05082,20.8757-17.86231,39.89659-39.89659,39.89659S854.7045,188.39316,853.463,166.39389c-1.5864-28.11068,17.354-40.013,39.89659-39.89658C919.99,126.63486,941.62378,141.61951,933.25616,166.39389Z"
              transform="translate(-128.46486 -95)"
              fill="#2f2e41"
            />
            <rect
              x="724.99812"
              y="68.24416"
              width="78.74327"
              height="99.74147"
              fill="#2f2e41"
            />
            <polygon
              points="595.444 372.758 315.865 372.758 244.319 709.574 666.99 709.574 595.444 372.758"
              fill="#f2f2f2"
            />
            <path
              d="M795.455,430.93825c0,6.08351-39.262,11.312-95.17433,13.52305-15.48987.6108-32.2501,1.00171-49.81662,1.09939q-5.03907.03668-10.15144.03668c-85.6826,0-155.14239-6.56-155.14239-14.65912S554.63,416.27912,640.31259,416.27912,795.455,422.83908,795.455,430.93825Z"
              transform="translate(-128.46486 -95)"
              fill="#3f3d56"
            />
            <rect
              x="254.39441"
              y="616.6206"
              width="382.14799"
              height="2.44295"
              transform="translate(-379.99186 830.03637) rotate(-77.99318)"
              fill="#3f3d56"
            />
            <rect
              x="833.93472"
              y="426.76808"
              width="2.44412"
              height="382.14799"
              transform="translate(-238.61428 92.01513) rotate(-11.99242)"
              fill="#3f3d56"
            />
            <rect
              y="707.30271"
              width="943.07028"
              height="2.44319"
              fill="#2f2e41"
            />
            <path
              d="M613.73478,432.00518l-5.01668-1.64256c-17.90559-6.03682-29.66891-9.89213-33.859-19.33671a14.69889,14.69889,0,0,1,7.5232-19.699,15.989,15.989,0,0,1,13.43334.28766,15.98839,15.98839,0,0,1,8.80178-10.15216,14.6989,14.6989,0,0,1,19.65306,7.64237c4.19009,9.4447-.8461,20.753-8.38683,38.07884Z"
              transform="translate(-128.46486 -95)"
              fill="#ff6584"
            />
            <path
              d="M700.28065,444.4613c-15.48987.6108-32.2501,1.00171-49.81662,1.09939a15.0415,15.0415,0,0,1,6.43782-5.375,15.96167,15.96167,0,0,1,13.4253.29317,16.02917,16.02917,0,0,1,8.80772-10.15144,14.70334,14.70334,0,0,1,19.6554,7.64719A17.64952,17.64952,0,0,1,700.28065,444.4613Z"
              transform="translate(-128.46486 -95)"
              fill="#ff6584"
            />
            <path
              d="M617.36274,276.82955l-2.0642-1.55853c-7.33987-5.64347-12.17948-9.29973-12.62069-14.34312a7.2022,7.2022,0,0,1,6.61739-7.9349,7.83435,7.83435,0,0,1,6.18061,2.26805,7.83407,7.83407,0,0,1,5.6929-3.30679,7.20221,7.20221,0,0,1,7.89467,6.66534c.44122,5.04345-3.69007,9.48452-9.93846,16.31667Z"
              transform="translate(-128.46486 -95)"
              fill="#ff6584"
            />
            <path
              d="M649.12417,193.76118l-2.0642-1.55853c-7.33986-5.64347-12.17948-9.29973-12.62069-14.34312a7.20221,7.20221,0,0,1,6.61739-7.9349,7.83431,7.83431,0,0,1,6.18061,2.26806,7.834,7.834,0,0,1,5.69291-3.30679,7.2022,7.2022,0,0,1,7.89467,6.66533c.44122,5.04345-3.69008,9.48452-9.93847,16.31667Z"
              transform="translate(-128.46486 -95)"
              fill="#ff6584"
            />
            <path
              d="M656.5452,345.69433l-.76664-4.3478c-2.60783-15.58686-4.40269-25.78323.9111-32.59774a12.29339,12.29339,0,0,1,17.4957-2.21868,13.37233,13.37233,0,0,1,5.08474,10.02135,13.37184,13.37184,0,0,1,10.95848,2.48876,12.2934,12.2934,0,0,1,2.11267,17.50882c-5.31386,6.8146-15.64028,7.55908-31.39252,8.82906Z"
              transform="translate(-128.46486 -95)"
              fill="#ff6584"
            />
            <path
              d="M283.47125,804.085l-2.17119-1.12139c28.19686-54.51242,13.119-125.3052-4.49389-175.09349a536.63547,536.63547,0,0,0-45.53836-96.10864l2.065-1.3051a539.3786,539.3786,0,0,1,45.77576,96.59775C296.88373,677.29813,312.06776,748.79715,283.47125,804.085Z"
              transform="translate(-128.46486 -95)"
              fill="#2f2e41"
            />
            <rect
              x="253.56806"
              y="573.2543"
              width="88.17503"
              height="2.44241"
              transform="matrix(0.17975, -0.98371, 0.98371, 0.17975, -449.43054, 669.02412)"
              fill="#2f2e41"
            />
            <rect
              x="237.79705"
              y="589.53078"
              width="2.44406"
              height="120.14546"
              transform="translate(-506.9529 241.87393) rotate(-42.93968)"
              fill="#2f2e41"
            />
            <rect
              x="290.93155"
              y="729.6177"
              width="70.86296"
              height="2.44356"
              transform="translate(-585.58879 472.17104) rotate(-54.13715)"
              fill="#2f2e41"
            />
            <circle
              cx="183.23904"
              cy="400.68271"
              r="12.21594"
              className="fill-primary blink-2"
            />
            <circle cx="50.08534" cy="494.74542" r="12.21594" fill="#3f3d56" />
            <circle cx="103.83546" cy="506.96136" r="12.21594" fill="#3f3d56" />
            <circle
              cx="79.40359"
              cy="554.60351"
              r="12.21594"
              className="fill-primary blink-2"
            />
            <circle cx="232.10279" cy="585.14335" r="12.21594" fill="#3f3d56" />
            <circle cx="191.7902" cy="598.58088" r="12.21594" fill="#3f3d56" />
            <circle cx="219.88685" cy="637.67187" r="12.21594" fill="#3f3d56" />
            <circle cx="91.61952" cy="415.34183" r="12.21594" fill="#3f3d56" />
            <path
              d="M934.51842,237.552H941.216s16.37193,20.837,8.93014,49.11579-1.48836,33.488-1.48836,33.488,9.68812,30.62355-.73038,76.76262,9.66053,58.67789,9.66053,58.67789L938.98349,418.3874,928.565,320.15582Z"
              transform="translate(-128.46486 -95)"
              className="fill-primary blink-2"
            />
            <path
              d="M934.51842,237.59H941.216s16.37193,20.837,8.93014,49.11579-1.48836,33.488-1.48836,33.488,9.68812,30.62355-.73038,76.76262,9.66053,58.67789,9.66053,58.67789l-18.60447-37.20893L928.565,320.19381Z"
              transform="translate(-128.46486 -95)"
              opacity="0.1"
            />
            <path
              d="M911.07679,201.45934s-5.95342,23.81371-2.97671,23.81371,13.39521,12.651,13.39521,12.651L928.1929,262.482l-5.20925,17.86029-17.86028-3.72089L882.798,252.06348l-6.69761-6.69761L870.147,223.78469s7.44179-8.93014,2.23254-16.37193S911.07679,201.45934,911.07679,201.45934Z"
              transform="translate(-128.46486 -95)"
              fill="#fbbebe"
            />
            <path
              d="M911.07679,201.45934s-5.95342,23.81371-2.97671,23.81371,13.39521,12.651,13.39521,12.651L928.1929,262.482l-5.20925,17.86029-17.86028-3.72089L882.798,252.06348l-6.69761-6.69761L870.147,223.78469s7.44179-8.93014,2.23254-16.37193S911.07679,201.45934,911.07679,201.45934Z"
              transform="translate(-128.46486 -95)"
              opacity="0.1"
            />
            <path
              d="M730.98557,267.69123,714.61364,240.9008S696.941,201.79838,684.29,215.93777s19.161,42.82332,19.161,42.82332l16.37193,21.58118Z"
              transform="translate(-128.46486 -95)"
              fill="#fbbebe"
            />
            <path
              d="M948.28572,500.61914,936.37887,587.688s1.48835,6.69761-13.39522,31.2555-55.06922,78.13876-55.06922,78.13876l-11.90685-22.32536s14.13939-70.697,38.69728-85.58054l-2.97671-107.16172Z"
              transform="translate(-128.46486 -95)"
              fill="#fbbebe"
            />
            <path
              d="M948.28572,500.61914,936.37887,587.688s1.48835,6.69761-13.39522,31.2555-55.06922,78.13876-55.06922,78.13876l-11.90685-22.32536s14.13939-70.697,38.69728-85.58054l-2.97671-107.16172Z"
              transform="translate(-128.46486 -95)"
              opacity="0.1"
            />
            <path
              d="M856.00758,665.82679l16.37193,31.2555s-13.39522,37.95311-8.186,41.674,11.90686,37.20893-2.23253,33.488-25.30208-18.60447-25.30208-20.837,8.186-33.488,3.7209-40.92983-7.44179-9.67432-7.44179-9.67432l-11.16268,18.60447-3.72089-2.23254,18.60446-31.2555s2.23254-5.95343,11.16268-9.67432Z"
              transform="translate(-128.46486 -95)"
              fill="#2f2e41"
            />
            <path
              d="M856.00758,665.82679l16.37193,31.2555s-13.39522,37.95311-8.186,41.674,11.90686,37.20893-2.23253,33.488-25.30208-18.60447-25.30208-20.837,8.186-33.488,3.7209-40.92983-7.44179-9.67432-7.44179-9.67432l-11.16268,18.60447-3.72089-2.23254,18.60446-31.2555s2.23254-5.95343,11.16268-9.67432Z"
              transform="translate(-128.46486 -95)"
              opacity="0.1"
            />
            <path
              d="M891.90179,488.26586s5.77979,82.30606-6.87125,103.88724V699.31482l-17.11611,2.23254s-29.023-58.04593-16.37192-113.85933S832.938,482.01467,832.938,482.01467Z"
              transform="translate(-128.46486 -95)"
              fill="#fbbebe"
            />
            <circle cx="759.17031" cy="93.43621" r="31.2555" fill="#fbbebe" />
            <path
              d="M919.26276,270.668l-31.2555-39.44147L870.147,219.31962l-7.44179,9.67432-20.837,5.95343s-13.39521,2.97672-27.5346,19.34865-39.44147,26.04625-39.44147,26.04625l-20.837-3.72089s-24.5579-11.16268-24.5579-14.1394S707.916,282.5748,713.12528,291.505s16.37193,20.09282,22.32536,26.04625,8.186,23.06954,44.65072,17.86029,49.86-23.06954,49.86-23.06954,6.6976,34.23221,26.04625,40.92982,82.60382,11.16268,82.60382,11.16268l13.39522-44.65072s14.88357-19.34864-5.20925-47.62743c0,0-.38575-15.81551-2.54585-26.33965-.84018-4.09344-1.94881-7.38636-3.40758-8.63674-5.20925-4.46507-32.74386-11.90686-32.74386-11.90686s4.46507,14.88357,6.69761,15.62775S922.23947,266.94705,919.26276,270.668Z"
              transform="translate(-128.46486 -95)"
              className="fill-primary blink-2"
            />
            <path
              d="M819.17074,492.80526c37.47673-2.60462,59.2961,3.53485,69.03,8.21572a24.67577,24.67577,0,0,1,5.07535,3.08091c.71438.60278,1.05668,1.07162,1.05668,1.35441,0,2.23253,51.34832,6.6976,69.95278,2.23253s-12.651-100.46411-20.837-108.65007-3.773-38.14661-3.773-38.14661-16.31979-3.5274-20.78486-2.039-27.53461-2.23253-35.72057-6.69761-18.60447-1.48835-25.30208-2.97671c-2.99161-.66233-4.50231.45394-5.25394,1.89765a12.86777,12.86777,0,0,1-5.09007,5.14225c-15.79889,9.10134-28.47973,72.02908-38.0276,106.81943C799.07791,500.99122,819.17074,492.80526,819.17074,492.80526Z"
              transform="translate(-128.46486 -95)"
              fill="#2f2e41"
            />
            <path
              d="M888.00726,692.61722l2.97671,16.37193s15.62775,22.32535,11.16268,40.92982c0,0,3.72089,24.55789,17.11611,31.2555s2.23253,22.32536-10.4185,21.58118-24.5579.74418-26.04625-2.97671-10.4185-40.18565-10.4185-40.18565l-2.44319,42.67115-7.44179.74418,2.44319-49.36876s-5.95343-11.16268,2.23254-29.76714l-2.066-28.5575S885.77472,700.059,888.00726,692.61722Z"
              transform="translate(-128.46486 -95)"
              fill="#2f2e41"
            />
            <path
              d="M888.20075,501.021a24.67577,24.67577,0,0,1,5.07535,3.08091c.39425-7.0325,2.67148-49.56233-.05959-48.87765Z"
              transform="translate(-128.46486 -95)"
              opacity="0.1"
            />
            <path
              d="M874.69616,145.39569s-.34614-1.92689-13.88381,3.14973-21.65256,42.53989-14.88373,64.5386c2.72782,8.86539.50879,15.25736-3.113,19.72968-13.59108,16.78288-8.24083,41.9903,11.55563,50.62063q.83817.36541,1.7106.72243l8.461,5.07663s-10.786-14.19212-5.38828-32.34645a93.0793,93.0793,0,0,0,1.67966-47.65026c-.61927-2.65858-1.3227-5.39907-2.12176-8.19575-6.76883-23.69091-3.47676-20.955,20.21415-44.64589,0,0,13.53767,10.15325,25.38313,15.22988s21.9987,10.15325,13.53766,27.07533-28.76754,32.152-15.22987,54.15066,15.22987,13.53767,13.53767,21.99871h0l-1.69221,8.461,10.15325-10.15325-6.76884,13.53766s21.99871,0,28.76754-16.92208l3.38442,3.38442s13.53766-23.69092-11.84546-45.68962c0,0-8.461-5.07663,3.38442-21.99871s2.748-53.30456-12.48187-60.07339S874.69616,145.39569,874.69616,145.39569Z"
              transform="translate(-128.46486 -95)"
              fill="#2f2e41"
            />
            <circle cx="764.89471" cy="24.14793" r="15.74865" fill="#2f2e41" />
            <path
              d="M874.46119,110.74865A15.7493,15.7493,0,0,1,888.635,95.07953C888.11688,95.02807,887.59179,95,887.06011,95a15.74865,15.74865,0,0,0,0,31.49731c.53168,0,1.05677-.02807,1.57486-.07953A15.74936,15.74936,0,0,1,874.46119,110.74865Z"
              transform="translate(-128.46486 -95)"
              fill="#2f2e41"
            />
            <path
              d="M689.43676,227.96581l-2.0642-1.55854c-7.33986-5.64346-12.17948-9.29973-12.62069-14.34311a7.2022,7.2022,0,0,1,6.61739-7.9349,7.8343,7.8343,0,0,1,6.18061,2.26805,7.834,7.834,0,0,1,5.69291-3.30679,7.2022,7.2022,0,0,1,7.89467,6.66533c.44122,5.04345-3.69008,9.48452-9.93847,16.31667Z"
              transform="translate(-128.46486 -95)"
              fill="#ff6584"
            />
            <circle cx="901.67862" cy="493.98532" r="18.02529" fill="#f1f1f1" />
            <circle cx="400.82523" cy="106.74014" r="18.02529" fill="#f1f1f1" />
            <circle cx="226.13734" cy="310.74627" r="18.02529" fill="#f1f1f1" />
          </svg>

          <svg
            xmlns={"http://www.w3.org/2000/svg"}
            xmlnsXlink={"http://www.w3.org/1999/xlink"}
            id={"downloads"}
            viewBox={"0 0 977.47786 801.93613"}
          >
            <defs>
              <linearGradient
                id="a7d70b19-b507-4394-a133-55f51a2376ed"
                x1="323.00662"
                y1="814.32902"
                x2="323.00662"
                y2="813.88035"
                gradientTransform="matrix(-1, 0, 0, 1, 651, 0)"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0" stop-color="gray" stop-opacity="0.25" />
                <stop offset="0.53514" stop-color="gray" stop-opacity="0.12" />
                <stop offset="1" stop-color="gray" stop-opacity="0.1" />
              </linearGradient>
            </defs>
            <title>download</title>
            <path
              d="M736.91966,127.882v610.02a27.40545,27.40545,0,0,1-27.41,27.4h-247.66a27.40545,27.40545,0,0,1-27.41-27.4V127.882a27.40759,27.40759,0,0,1,27.41-27.41h37.06V105.232a22.57647,22.57647,0,0,0,22.57,22.57h125.95a22.57,22.57,0,0,0,22.57-22.57V100.472h39.51A27.40759,27.40759,0,0,1,736.91966,127.882Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#f2f2f2"
            />
            <path
              d="M774.23126,223.30777h2.45455a2.29166,2.29166,0,0,1,2.29166,2.29166v80.43684a2.29167,2.29167,0,0,1-2.29166,2.29167h-2.45455"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M429.12694,184.69093H427.3524a1.50327,1.50327,0,0,1-1.50327-1.50327V158.20489a1.50327,1.50327,0,0,1,1.50327-1.50327h1.77454"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M428.848,256.66345h-1.5147a1.69459,1.69459,0,0,1-1.69459-1.69459v-45.329a1.69459,1.69459,0,0,1,1.69459-1.6946h1.79366"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M428.848,322.84871h-1.49148a1.61261,1.61261,0,0,1-1.6126-1.6126V275.32217a1.6126,1.6126,0,0,1,1.6126-1.61259H428.848"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <rect
              x="317.6162"
              y="15.42306"
              width="345.10432"
              height="701.37379"
              rx="35.69395"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <rect
              x="454.87844"
              y="39.36805"
              width="48.19213"
              height="9.78574"
              rx="2.54189"
              fill="#f2f2f2"
            />
            <circle cx="515.90777" cy="44.26092" r="5.55051" fill="#f2f2f2" />
            <rect
              x="456.87844"
              y="36.36805"
              width="48.19213"
              height="9.78574"
              rx="2.54189"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <circle
              cx="517.90777"
              cy="41.26092"
              r="5.55051"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M752.91966,109.882v610.02a27.40545,27.40545,0,0,1-27.41,27.4h-247.66a27.40545,27.40545,0,0,1-27.41-27.4V109.882a27.40759,27.40759,0,0,1,27.41-27.41h37.06V87.232a22.57647,22.57647,0,0,0,22.57,22.57h125.95a22.57,22.57,0,0,0,22.57-22.57V82.472h39.51A27.40759,27.40759,0,0,1,752.91966,109.882Z"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <rect
              x="347.57891"
              y="91.99008"
              width="31"
              height="4"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <rect
              x="347.57891"
              y="98.99008"
              width="31"
              height="4"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <rect
              x="347.57891"
              y="105.99008"
              width="31"
              height="4"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M738.75456,150.772h-.91824l-.34477-.28784a7.62034,7.62034,0,0,0,1.77982-4.893,7.43383,7.43383,0,1,0-7.405,7.48343,7.6931,7.6931,0,0,0,4.87907-1.78434l.34424.2879v.92086l5.74018,5.75644,1.722-1.72693Zm-6.88823,0a5.18086,5.18086,0,1,1,5.16612-5.18086A5.15205,5.15205,0,0,1,731.86633,150.772Z"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M906.66523,217.77107a38.95007,38.95007,0,0,1,38.89611-36.91443c1.18377,0,2.35271.06174,3.50958.16513a51.74974,51.74974,0,0,1,89.45652-.04229c.976-.07331,1.95855-.12284,2.95327-.12284a38.95007,38.95007,0,0,1,38.89611,36.91443"
              transform="translate(-111.51074 -48.78194)"
              fill="#f2f2f2"
            />
            <path
              d="M914.77767,214.77486a38.95008,38.95008,0,0,1,38.89611-36.91442c1.18377,0,2.35271.06173,3.50959.16513a51.74974,51.74974,0,0,1,89.45651-.0423c.976-.0733,1.95855-.12283,2.95328-.12283a38.95007,38.95007,0,0,1,38.8961,36.91442"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M802.66523,438.77107a38.95007,38.95007,0,0,1,38.89611-36.91443c1.18377,0,2.35271.06174,3.50958.16513a51.74974,51.74974,0,0,1,89.45652-.04229c.976-.07331,1.95855-.12284,2.95327-.12284a38.95007,38.95007,0,0,1,38.89611,36.91443"
              transform="translate(-111.51074 -48.78194)"
              fill="#f2f2f2"
            />
            <path
              d="M810.77767,435.77486a38.95008,38.95008,0,0,1,38.89611-36.91442c1.18377,0,2.35271.06173,3.50959.16513a51.74974,51.74974,0,0,1,89.45651-.0423c.976-.0733,1.95855-.12283,2.95328-.12283a38.95007,38.95007,0,0,1,38.8961,36.91442"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M151.66523,114.77107a38.95007,38.95007,0,0,1,38.89611-36.91443c1.18377,0,2.35271.06174,3.50958.16513a51.74974,51.74974,0,0,1,89.45652-.04229c.976-.07331,1.95855-.12284,2.95327-.12284a38.95007,38.95007,0,0,1,38.89611,36.91443"
              transform="translate(-111.51074 -48.78194)"
              fill="#f2f2f2"
            />
            <path
              d="M159.77767,111.77486a38.95008,38.95008,0,0,1,38.89611-36.91442c1.18377,0,2.35271.06173,3.50959.16513a51.74974,51.74974,0,0,1,89.45651-.0423c.976-.0733,1.95855-.12283,2.95328-.12283a38.95007,38.95007,0,0,1,38.8961,36.91442"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <rect
              x="349.07891"
              y="194"
              width="238"
              height="132"
              rx="12.54724"
              className="fill-primary blink-3"
            />
            <rect
              x="362.07891"
              y="169"
              width="238"
              height="132"
              rx="12.54724"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M555.05822,313.30129l20.99113,21.6334a4.77133,4.77133,0,0,0,3.509,1.40985h.06266a4.77133,4.77133,0,0,0,3.509-1.40985l20.99113-21.6334a4.63225,4.63225,0,0,0,0-6.76729,5.18146,5.18146,0,0,0-7.08059,0l-12.438,13.002V286.01282a5.01782,5.01782,0,0,0-10.02561,0V319.536l-12.438-13.002a5.18144,5.18144,0,0,0-7.08059,0,4.63225,4.63225,0,0,0,0,6.76729Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#fff"
            />
            <rect
              x="486.58964"
              y="468.78194"
              width="238"
              height="132"
              rx="12.54724"
              transform="translate(1099.66855 1020.78194) rotate(-180)"
              className="fill-primary"
            />
            <rect
              x="473.58964"
              y="443.78194"
              width="238"
              height="132"
              rx="12.54724"
              transform="translate(1073.66855 970.78194) rotate(-180)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M630.12107,539.3013a4.63225,4.63225,0,0,0,0-6.76729,5.18144,5.18144,0,0,0-7.08059,0l-12.438,13.002V512.01282a5.01782,5.01782,0,0,0-10.02561,0V545.536l-12.438-13.002a5.18146,5.18146,0,0,0-7.08059,0,4.63225,4.63225,0,0,0,0,6.76729l20.99113,21.6334a4.77131,4.77131,0,0,0,3.509,1.40985h.06266a4.77133,4.77133,0,0,0,3.509-1.40985l20.99113-21.6334Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#fff"
            />
            <path
              d="M328.41943,813.88035l-.00036.00132s-.31446.17476-.85173.44735Q328.00131,814.10425,328.41943,813.88035Z"
              transform="translate(-111.51074 -48.78194)"
              fill="url(#a7d70b19-b507-4394-a133-55f51a2376ed)"
            />
            <path
              d="M209.15378,709.08421c-7.50261,21.57,1.252,56.58375,5.3174,72.2126,4.06086,15.63357,5.31282,34.39008,5.31282,34.39008,15.943,2.49932,27.51109-.62835,27.51109-.62835L240.73031,782.863c4.68913-19.07068,0-70.02747,0-70.02747s10.62564-19.69435,11.56346-49.70478c.92375-29.54151,8.206-39.08857,8.43574-39.384l.0047-.0047c15.00521,7.8168,34.07586,91.59747,34.07586,91.59747-1.56151,20.318.31414,51.58043,6.56478,68.46129a84.75941,84.75941,0,0,1,4.68913,33.44757c2.1851,1.84752,5.2237,2.16168,8.50609,1.63181,8.92807-1.44426,19.62869-9.13441,19.62869-9.13441s-3.43717-91.28331-5.94109-94.72042c-2.49934-3.43714,0-23.13148,0-23.13148l-4.06086-31.88609s.62369-54.08443-5.3174-63.46269c-5.12524-8.0981-6.30691-22.32963-6.53667-26.06685-.0328-.59084-.04688-.91908-.04688-.91908l-9.04535-10.83657s-87.532-6.56478-94.09673,0c-1.61309,1.61306-2.60718,5.27527-3.198,9.88938-1.80536,14.17993.26262,37.31138.26262,37.31138s2.62585,17.19506,6.37715,34.69956a76.00815,76.00815,0,0,1,0,31.88608A95.36238,95.36238,0,0,1,209.15378,709.08421Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#575a89"
            />
            <path
              d="M214.626,846.16621c3.90608,5.158,26.88281,2.96825,30.79348,1.35991,2.3868-.98476,2.20861-5.47692,1.56151-10.10509-.40795-2.94479-1.00817-5.94584-1.252-8.13569-.62369-5.62693,1.87565-17.04028,1.87565-17.04028s-5.158,5.47224-6.40542,0c-.54773-2.392-2.47139-3.61818-4.46219-4.24074a11.67771,11.67771,0,0,0-8.11578.509c-4.0596,1.76022-10.83558,5.51663-9.6203,10.59667,1.72088,7.17909-4.375,17.36386-4.375,17.36386a7.81407,7.81407,0,0,0-1.13943,1.96472A7.51005,7.51005,0,0,0,214.626,846.16621Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#cbceda"
            />
            <path
              d="M214.626,846.16621c3.90608,5.158,26.88281,2.96825,30.79348,1.35991,2.3868-.98476,2.20861-5.47692,1.56151-10.10509-2.46672,1.15479-6.66321,2.11353-13.658,1.46667a39.31042,39.31042,0,0,0-4.91278-.15072,114.95661,114.95661,0,0,1-14.92361-.29845A7.51005,7.51005,0,0,0,214.626,846.16621Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M294.81007,715.33952c-1.56151,20.318.31414,51.58043,6.56478,68.46129a84.75941,84.75941,0,0,1,4.68913,33.44757c2.1851,1.84752,5.2237,2.16168,8.50609,1.63181-1.885-13.18583-9.92221-69.99464-15.07087-114.87429-5.86141-51.11151-33.29282-86.28-33.29282-86.28l-5.47217,6.01613C275.73942,631.55885,294.81007,715.33952,294.81007,715.33952Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M224.00422,386.78629l3.817,18.75652L246.512,436.96l23.05641-9.84717s31.33749-32.82391,11.64315-37.513a17.33077,17.33077,0,0,1-6.54131-2.912c-3.86384-2.91662-5.08306-7.15561-5.10184-11.30548a34.63938,34.63938,0,0,1,3.20271-13.44842l-40.32651-12.66065a64.4,64.4,0,0,1,2.89316,16.33691c.30955,10.982-3.77,16.39321-7.11807,18.97223A12.11163,12.11163,0,0,1,224.00422,386.78629Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#fbbebe"
            />
            <path
              d="M232.44465,349.27326a64.4,64.4,0,0,1,2.89316,16.33691,30.994,30.994,0,0,0,2.34456,2.49462,31.9113,31.9113,0,0,0,31.88608,7.27754,34.63938,34.63938,0,0,1,3.20271-13.44842Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M227.82118,344.11522a31.88492,31.88492,0,1,0,31.88608-31.88609A31.76788,31.76788,0,0,0,227.82118,344.11522Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#fbbebe"
            />
            <path
              d="M224.00422,386.78629l3.817,18.75652L246.512,436.96l23.05641-9.84717s31.33749-32.82391,11.64315-37.513a17.33077,17.33077,0,0,1-6.54131-2.912c3.559,9.77216-11.12261,30.10891-11.12261,30.10891-1.7069,2.51337-5.627.93783-5.627.93783-9.45336-1.43018-26.864-28.62713-29.701-33.15215A12.11163,12.11163,0,0,1,224.00422,386.78629Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M205.95576,568.612c5.54728,1.26138,36.26108,8.06528,47.90411,6.36313,12.81543-1.87565,37.73347-3.12295,37.73347-3.12295s15.868.85812,20.7494-1.37391c-.0328-.59084-.04688-.91908-.04688-.91908l-9.04535-10.83657s-87.532-6.56478-94.09673,0C207.54069,560.33566,206.5466,563.99787,205.95576,568.612Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M263.54921,417.73455s16.49322-22.85,10.27857-31.74456l27.85968,11.425s16.76883-2.03259,22.82,22.99209a43.2943,43.2943,0,0,1,1.03593,12.70146c-.2198,3.77329.29307,10.41622,4.59144,19.013,6.87739,13.75478,5.31435,45.32825-8.753,48.45434s-19.06913,1.563-19.06913,1.563,1.87565,57.20738,10.00348,63.77216-20.72319,5.00174-20.72319,5.00174-24.91767,1.25043-37.73463,3.12609-48.76694-6.56479-48.76694-6.56479,5.31434-24.07086,7.19-39.38868,6.25218-47.935,6.25218-47.935L186.64749,436.96s-5.627-26.10282,14.06738-37.66934,27.10594-14.41034,27.10594-14.41034,19.78536,32.229,30.10144,33.79207C257.92225,418.67237,261.84111,420.247,263.54921,417.73455Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#3f3d56"
            />
            <path
              d="M300.12442,426.8002s.31261,10.31608-1.563,14.38-8.753,26.57173-8.753,26.57173h15.63043s-8.44044-9.06565-7.81522-13.44217S300.12442,426.8002,300.12442,426.8002Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M253.85834,504.63975s34.51754-8.44043,37.73463-15.63043,12.08431-23.27994,12.08431-23.27994l-3.6435-4.90768-16.79023,13.1824s-20.007,15.943-29.38521,17.50609S253.85834,504.63975,253.85834,504.63975Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#fbbebe"
            />
            <path
              d="M253.85834,504.63975s34.51754-8.44043,37.73463-15.63043,12.08431-23.27994,12.08431-23.27994l-3.6435-4.90768-16.79023,13.1824s-20.007,15.943-29.38521,17.50609S253.85834,504.63975,253.85834,504.63975Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.05"
            />
            <path
              d="M224.00422,464.00218v18.72839h3.01038a87.60925,87.60925,0,0,1,42.507,11.0007l5.641,3.13234,1.51933.844,9.6877-21.8279-9.06412-8.12627s-.164.01875-.46422.04222c-2.21795.21568-11.8072,1.01753-15.87264-.35638-3.8592-1.30828-8.65617-5.46754-20.02731-2.56027-5.59885,1.43017-10.38174,7.70893-15.81642,5.74887Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#fbbebe"
            />
            <path
              d="M193.83748,429.92629,187.58531,436.96v17.03717s5.31435,53.76868,22.19522,59.70825,47.01551-3.4387,47.01551-3.4387,7.78284-20.63217,4.14192-21.8826-32.17932-8.78853-32.17932-8.78853.40362-31.538-5.84855-40.91624c0,0,4.06391-29.38521-10.00348-30.01043S193.83748,429.92629,193.83748,429.92629Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M192.89966,429.92629,186.64749,436.96v17.03717s5.31434,53.76868,22.19521,59.70825,47.01551-3.4387,47.01551-3.4387,7.78285-20.63217,4.14192-21.8826-32.17932-8.78853-32.17932-8.78853.40362-31.538-5.84855-40.91624c0,0,4.06391-29.38521-10.00347-30.01043S192.89966,429.92629,192.89966,429.92629Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#3f3d56"
            />
            <path
              d="M236.56641,357.66678a12.48011,12.48011,0,0,1,.71276-6.08648c.8815-1.86626,2.94479-3.33866,4.95639-2.865,2.67753.62366,3.831,4.10768,6.45224,4.94233,2.20856.70337,4.62348-.86278,5.67853-2.9307,1.05506-2.0632,1.08322-4.48281,1.08791-6.79924q.00705-3.91773.01872-7.83552c.00469-2.84161.08912-5.913,1.84285-8.145,2.1804-2.78065,7.301-3.99515,10.71935-3.88262a9.06655,9.06655,0,0,1,6.11928,2.46649c1.83346,1.55679,3.94826,2.70094,6.44285,2.293a5.56289,5.56289,0,0,0,4.48753-3.88261.74891.74891,0,0,0,.02347-.09846A31.88386,31.88386,0,1,0,237.68237,367.167,86.17382,86.17382,0,0,1,236.56641,357.66678Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M280.59819,327.8867a5.57013,5.57013,0,0,0,4.48868-3.88363c.26277-1.00923.19378-2.08595.49087-3.08563.72987-2.456,3.35193-3.73664,5.10939-5.601,3.52273-3.737,3.29388-9.88525.80025-14.37486-2.01246-3.62329-5.9165-6.68277-10.0002-5.97456-2.52823.43846-4.71565,2.24069-7.27649,2.403-2.46538.15625-4.72281-1.22478-6.9702-2.25035a26.27874,26.27874,0,0,0-17.28014-1.53364,9.95578,9.95578,0,0,0-4.7546,2.39808,40.49992,40.49992,0,0,0-2.53626,3.565c-2.91619,3.71368-8.13178,4.43893-12.77774,5.28192s-9.904,2.67643-11.431,7.14453c-1.01248,2.96262-.03034,6.18027.5514,9.2566a2.7207,2.7207,0,0,1-.124,1.911c-.72469,1.1988-2.53916.69713-3.91012.98483-2.636.55315-3.31345,3.94914-3.41048,6.64078q-.16657,4.6209-.251,9.24428a11.95061,11.95061,0,0,0,.27282,3.4307,12.12149,12.12149,0,0,0,2.65863,4.30246l10.32256,12.40088c4.57684,5.49834,9.43745,11.90706,8.51506,19.00132,2.16944.97347,4.74556-.89925,5.457-3.16818s.13686-4.71336-.34515-7.04184a86.57534,86.57534,0,0,1-1.632-12.20814,12.43913,12.43913,0,0,1,.71577-6.086c.87906-1.86884,2.94475-3.33839,4.95576-2.8681,2.67772.62619,3.82987,4.10859,6.45,4.94372,2.20874.704,4.62644-.8646,5.67966-2.92977s1.08142-4.48233,1.0869-6.80055l.0185-7.83578c.0067-2.83917.09052-5.91266,1.84278-8.14658,2.18022-2.7795,7.30318-3.99368,10.72225-3.88259a9.07916,9.07916,0,0,1,6.11684,2.46757C275.98838,327.14949,278.1011,328.29349,280.59819,327.8867Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#3f3d56"
            />
            <path
              d="M273.39638,426.01868l-9.78975,40.21522S255.8903,466.18889,273.39638,426.01868Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M239.94726,419.29759s12.81695,20.99063,7.81521,42.694l-2.38793.17446S249.63813,452.1215,239.94726,419.29759Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M231.81943,538.08887s-15.73783-5.20547-16.88086,6.87739C214.93857,544.96626,217.90835,536.68213,231.81943,538.08887Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M277.304,468.68976s3.12609,21.8826-2.50087,30.63564c0,0,11.44573,4.68913,27.50956,3.75131l1.87565-34.387Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M275.16261,496.86361l1.51933.844,9.6877-21.8279-9.06412-8.12627h-.46892a.28883.28883,0,0,0,.0047.04222C276.982,468.80385,279.50944,487.59788,275.16261,496.86361Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M277.304,467.75193s3.12609,21.8826-2.50087,30.63565c0,0,11.44573,4.68913,27.50956,3.7513l10.9413-34.38695Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#3f3d56"
            />
            <path
              d="M302.34272,840.85467a7.07925,7.07925,0,0,0,6.0706,6.19285c8.48992,1.26827,28.93735-2.49741,34.10153-.04073,6.56478,3.12767,32.50977.93783,33.76173-2.18515a4.93352,4.93352,0,0,0-.45014-3.76069,9.98125,9.98125,0,0,0-4.19211-4.50619,10.38642,10.38642,0,0,0-1.88029-.83468c-4.88615-1.6318-14.119-5.09244-16.609-8.71713,0,0-11.50477-10.06664-14.78839-15.51105a7.50969,7.50969,0,0,0-6.01019-3.74308c-2.73846-.1225-5.78874,1.25493-7.036,7.25466,0,0-14.99583,8.55767-19.05669,1.05506,0,0-.62358,18.52586-3.11353,21.677-.00469.00469-.00939.014-.01408.01871A4.161,4.161,0,0,0,302.34272,840.85467Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#cbceda"
            />
            <path
              d="M302.34272,840.85467a7.07925,7.07925,0,0,0,6.0706,6.19285c8.48992,1.26827,28.93735-2.49741,34.10153-.04073,6.56478,3.12767,32.50977.93783,33.76173-2.18515a4.93352,4.93352,0,0,0-.45014-3.76069,9.98125,9.98125,0,0,0-4.19211-4.50619c-4.22955,2.80409-13.62189,5.55192-34.27753,2.32579-19.70373-3.07609-29.45714.90883-34.21656-1.145-.00469.00469-.00939.014-.01408.01871A4.161,4.161,0,0,0,302.34272,840.85467Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <g opacity="0.1">
              <path
                d="M219.04105,321.67135c-.00882-.05014-.0174-.10054-.02679-.15-.443-2.34276-1.11573-4.76718-.9653-7.09881a45.60409,45.60409,0,0,0,.9653,5.69207A3.38839,3.38839,0,0,1,219.04105,321.67135Z"
                transform="translate(-111.51074 -48.78194)"
              />
              <path
                d="M237.2832,350.93339a9.1354,9.1354,0,0,0-.76759,3.57228,10.76385,10.76385,0,0,1,.76759-4.979c.8791-1.86884,2.94479-3.33837,4.95576-2.86811,2.6777.6262,3.82984,4.10859,6.45,4.94373,2.20879.704,4.62651-.86462,5.67973-2.92976s1.08138-4.48235,1.08688-6.80056q.00927-3.9179.01843-7.83577c.00675-2.83918.09055-5.91267,1.84279-8.14659,2.18029-2.77951,7.30319-3.99369,10.72227-3.88258a9.07894,9.07894,0,0,1,6.11682,2.46757c1.83466,1.55734,3.94735,2.70132,6.44446,2.29454a5.57021,5.57021,0,0,0,4.48867-3.88362c.26273-1.00923.19376-2.08595.49089-3.08563.72982-2.456,3.35188-3.73665,5.10939-5.601a10.23456,10.23456,0,0,0,2.63678-6.6074,10.65727,10.65727,0,0,1-2.63678,8.01414c-1.75751,1.86437-4.37957,3.145-5.10939,5.601-.29713.99968-.22816,2.0764-.49089,3.08563a5.57021,5.57021,0,0,1-4.48867,3.88362c-2.49711.40677-4.6098-.7372-6.44446-2.29454a9.079,9.079,0,0,0-6.11682-2.46758c-3.41908-.1111-8.542,1.10308-10.72227,3.88259-1.75224,2.23392-1.836,5.30741-1.84279,8.14659q-.00911,3.91785-.01843,7.83577c-.0055,2.31821-.03366,4.73538-1.08688,6.80056s-3.47094,3.63379-5.67973,2.92976c-2.62012-.83514-3.77226-4.31753-6.45-4.94374C240.228,347.595,238.1623,349.06455,237.2832,350.93339Z"
                transform="translate(-111.51074 -48.78194)"
              />
              <path
                d="M211.59145,342.32619a12.12287,12.12287,0,0,0,2.65858,4.30247q5.16124,6.20041,10.32261,12.40086c4.34546,5.22043,8.943,11.262,8.60758,17.9314-.31345-6.11379-4.56962-11.67371-8.60758-16.52466q-5.16125-6.20041-10.32261-12.40087a12.12269,12.12269,0,0,1-2.65858-4.30247,11.94551,11.94551,0,0,1-.27281-3.42949A8.50743,8.50743,0,0,0,211.59145,342.32619Z"
                transform="translate(-111.51074 -48.78194)"
              />
              <path
                d="M238.54467,374.86269a7.34444,7.34444,0,0,0,.30864-1.67277,8.3752,8.3752,0,0,1-.30864,3.07951c-.71139,2.26892-3.28755,4.14162-5.457,3.16816a13.61224,13.61224,0,0,0,.107-1.36773C235.34127,378.937,237.84485,377.09469,238.54467,374.86269Z"
                transform="translate(-111.51074 -48.78194)"
              />
            </g>
            <path
              d="M340.41866,814.32139s-3.26664,5.74843-15.1082.68209"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M242.31847,814.7062s-10.21432,12.02272-23.08215,3.94222"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M212.59553,672.509s7.21512,4.5073,7.44958,7.08633-3.72479-1.87566-3.72479-1.87566Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M209.74816,707.07414a15.06635,15.06635,0,0,0,8.89021,3.46944c5.3925.23446,4.94362,7.26815,1.41675,5.158S209.74816,707.07414,209.74816,707.07414Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M208.37518,711.58507s3.464,17.01166,6.27743,13.72927"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.1"
            />
            <path
              d="M125.22035,694.43414a20.81252,20.81252,0,1,0,2.7716-39.91524l.52093,10.7122-5.06815-9.18045a20.734,20.734,0,0,0-10.68366,11.72261,20.40847,20.40847,0,0,0-1.19713,5.62986A20.80855,20.80855,0,0,0,125.22035,694.43414Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#57b894"
            />
            <path
              d="M150.29769,818.67756c-1.78906-9.11027,5.96331-17.1868,13.62087-22.43651s16.605-10.40779,19.21775-19.31684c3.755-12.80387-7.43-24.52981-16.13564-34.64176a125.3,125.3,0,0,1-16.52359-24.55738c-1.81108-3.5325-3.47558-7.22528-3.95222-11.16626-.6864-5.67546,1.13694-11.32309,2.97391-16.73673q9.17923-27.05169,19.62842-53.65005"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M126.07747,691.6762a20.81252,20.81252,0,1,0,2.77159-39.91524l.52094,10.7122-5.06815-9.18045a20.734,20.734,0,0,0-10.68367,11.72261,20.40883,20.40883,0,0,0-1.19713,5.62986A20.80857,20.80857,0,0,0,126.07747,691.6762Z"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M147.75389,632.47266A20.78823,20.78823,0,0,1,162.73382,619.275l1.71362,10.18378,3.177-10.69566a20.81,20.81,0,1,1-19.87057,13.70952Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#57b894"
            />
            <path
              d="M148.89672,628.7954a20.7882,20.7882,0,0,1,14.97993-13.19763l1.71361,10.18378,3.177-10.69567a20.81,20.81,0,1,1-19.87057,13.70952Z"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M163.34728,742.48885a20.81,20.81,0,0,0,18.419-37.02267l-2.44122,8.21926-1.731-10.30382a.3621.3621,0,0,0-.053-.0201,20.81113,20.81113,0,1,0-14.1938,39.12733Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#57b894"
            />
            <path
              d="M164.33749,738.76417a20.81,20.81,0,0,0,18.419-37.02267l-2.44121,8.21926-1.73105-10.30382a.36183.36183,0,0,0-.053-.0201,20.81113,20.81113,0,1,0-14.1938,39.12733Z"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M141.68036,777.05148a20.80131,20.80131,0,1,0,4.01058-16.29737l9.27267,13.95654L142.29366,767.303A20.61637,20.61637,0,0,0,141.68036,777.05148Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#57b894"
            />
            <path
              d="M142.53747,774.29354a20.80132,20.80132,0,1,0,4.01059-16.29737l9.27266,13.95655L143.15078,764.545A20.61651,20.61651,0,0,0,142.53747,774.29354Z"
              transform="translate(-111.51074 -48.78194)"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
            <path
              d="M121.40226,831.01764s18.36546-7.19731,23.90035-11.13863,28.2507-8.64747,29.62377-2.32646,27.59987,31.43784,6.86536,31.60509-48.17778,3.40194-53.702.03692S121.40226,831.01764,121.40226,831.01764Z"
              transform="translate(-111.51074 -48.78194)"
              fill="#656380"
            />
            <path
              d="M182.16177,846.95727c-20.73451.16729-48.17777,3.402-53.702.03693-4.207-2.56265-5.88345-11.75807-6.44438-16.00047-.38846.0167-.61311.02389-.61311.02389s1.16323,14.81188,6.68747,18.17692,32.9675.13036,53.702-.03693c5.98523-.04827,8.05264-2.17773,7.93912-5.33164C188.89938,845.73148,186.61666,846.92135,182.16177,846.95727Z"
              transform="translate(-111.51074 -48.78194)"
              opacity="0.2"
            />
            <line
              x1="50.81609"
              y1="799.55547"
              x2="322.81609"
              y2="799.55547"
              fill="none"
              stroke="#3f3d56"
              stroke-miterlimit="10"
            />
          </svg>
        </div>

        <div className="cen-div">
          <h3
            style={{
              color: "white",
              fontSize: "45px",
              fontWeight: "800",
              paddingBottom: "20px",
            }}
          >
            OUR STATS{" "}
          </h3>
          <div className="container container-x">
            <div className="stat row text-center">
              <div className="stat-item col-lg-4 col-sm-12 col-xs-12 col-md-6">
                <div className="stat-card">
                  <h3 className="stat-title">
                    <span className="prefix">YEARS OF EXPERIENCE</span>
                    <span className="value">
                      <CountUp end={10}>
                        {({ countUpRef, start }) => (
                          <VisibilitySensor onChange={start} delayedCall>
                            <span ref={countUpRef} />
                          </VisibilitySensor>
                        )}
                      </CountUp>
                      +
                    </span>
                  </h3>
                  <div className="stat-icon">
                    <svg>
                      <use xlinkHref="#view" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="stat-item col-lg-4 col-sm-12 col-xs-12 col-md-6">
                <div className="stat-card">
                  <h3 className="stat-title">
                    <span className="prefix">MEMBERS</span>
                    <span className="value">
                      <CountUp end={1000}>
                        {({ countUpRef, start }) => (
                          <VisibilitySensor onChange={start} delayedCall>
                            <span ref={countUpRef} />
                          </VisibilitySensor>
                        )}
                      </CountUp>
                      +
                    </span>
                  </h3>
                  <div className="stat-icon">
                    <svg>
                      <use xlinkHref="#downloads" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="stat-item col-lg-4 col-sm-12 col-xs-12 col-md-6">
                <div className="stat-card">
                  <h3 className="stat-title">
                    <span className="prefix">SOCIAL MEDIA</span>
                    <span className="value">
                      <CountUp end={60000}>
                        {({ countUpRef, start }) => (
                          <VisibilitySensor onChange={start} delayedCall>
                            <span ref={countUpRef} />
                          </VisibilitySensor>
                        )}
                      </CountUp>
                      +
                    </span>
                  </h3>
                  <div className="stat-icon">
                    <svg>
                      <use xlinkHref="#like" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stat;
